module.exports = __webpack_public_path__ + "static/media/logo-auth.de4e3cbc.gif";